import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var paragraph_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "m9.99609 14v-.2251l.00391.0001v6.225h1.5v-14.5h2.5v14.5h1.5v-14.5h3v-1.5h-8.50391c-2.76142 0-5 2.23858-5 5 0 2.7614 2.23858 5 5 5z" }) });
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph.js.map
